import { api } from './client'

export type AbVariant = 'a' | 'b'

export type AbEventType =
  | 'assign'
  | 'view'
  | 'task_created'
  | 'task_succeeded'
  | 'task_failed'

export interface AbEventBody {
  variant: AbVariant
  event_type: AbEventType
  client_id: string
  meta?: Record<string, unknown>
}

export interface AbVariantBucket {
  variant: AbVariant
  assigned: number
  views: number
  tasks_created: number
  tasks_succeeded: number
  tasks_failed: number
  unique_visitors: number
  conversion_rate: number
}

export interface AbStats {
  generated_at: string
  window_hours: number
  total_events: number
  variants: AbVariantBucket[]
}

export const abApi = {
  recordEvent(body: AbEventBody): Promise<void> {
    return api.post<void>('/ab/event', body)
  },
  stats(hours = 24 * 30): Promise<AbStats> {
    return api.get<AbStats>('/ab/stats', { query: { hours } })
  },
}
